import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import * as sweetalert from "sweetalert";
import packageJson from "../../package.json";

export const BaseUrl = packageJson.projectURlApi.BaseUrl;

export const fectchprvicepoliceCompany = createAsyncThunk(
  "PoliceCompany/fectchprvicepoliceCompany",
  async (id, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const res = await axios.get(`${BaseUrl}/getPrivacyPolicyCompany/${id}`, {
                headers: {
        'Authorization': `Bearer ${localStorage.getItem('token')}`, // Add the auth token from localStorage
        'Content-Type': 'application/json'
      }, 
      });
      const result = await res.data.data;
      return result;
    } catch (error) {
      if (error.response && error.response.status === 401) {
        //Handle the 500 error server   error specifically
        localStorage.removeItem("isLoggedIn");
        window.location.reload()
      } 
      return rejectWithValue(error.message);
    }
  }
);
export const insertPriveePoliceCompany = createAsyncThunk(
  "PoliceCompany/insertPriveePoliceCompany",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {

      await axios.post(`${BaseUrl}/updatePrivacyPolicyCompany/${data.get('id')}`, data, {
                headers: {
        'Authorization': `Bearer ${localStorage.getItem('token')}`, // Add the auth token from localStorage
        'Content-Type': 'application/json'
      }, 
      });
      sweetalert({
        text: "تمت إضافة البيانات بنجاح",
        icon: "success",
        buttons: {
          confirm: {
            text: "تم",
            className: "custom-button-class",
          },
        },
        className: "alert-div",
      }).then(() => {
      });
    } catch (error) {
      if (error.response && error.response.status === 500) {
        sweetalert({
          text: error.response.data.message,
          icon: 'error',
          buttons: {
            confirm: {
              text: 'تم',
              className: 'custom-button-class',
            },
          },
          className: 'alert-div',
        });
      } 
     else if (error.response && error.response.status === 401) {
        //Handle the 500 error server   error specifically
        localStorage.removeItem("isLoggedIn");
        window.location.reload()
      } 
      else {
        sweetalert({
          text: error.response.data.message,
          icon: 'error',
          buttons: {
            confirm: {
              text: 'تم',
              className: 'custom-button-class',
            },
          },
          className: 'alert-div',
        });
      }
      return rejectWithValue(error.message);
    }
  }
);
const PriveePoliceCompanySlice = createSlice({
  name: "PriveePoliceCompany",
  initialState: {
    PriveePoliceCompany: [],
    insertPriveePoliceCompany: [],
    loading: false,
    error: null,
  },
  reducers: {
    clearPriveePoliceCompany: (state) => {
      state.PriveePoliceCompany = [];
      state.insertPriveePoliceCompany = [];
      state.loading = false;
      state.error = null;
    },
    
  },
  extraReducers: {
    //fetch Privec Police
    [fectchprvicepoliceCompany.pending]: (state, action) => {
      state.loading = true;
      state.error = null;
    },
    [fectchprvicepoliceCompany.fulfilled]: (state, action) => {
      state.PriveePoliceCompany = action.payload;
      state.loading = false;
    },
    [fectchprvicepoliceCompany.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    //insert Privec Police Company
    [insertPriveePoliceCompany.pending]: (state, action) => {
      state.loading = true;
      state.error = null;
    },
    [insertPriveePoliceCompany.fulfilled]: (state, action) => {
      state.insertPriveePoliceCompany = action.payload;
      state.loading = false;
    },
    [insertPriveePoliceCompany.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
  },
});
export const { clearPriveePoliceCompany } = PriveePoliceCompanySlice.actions;
export default PriveePoliceCompanySlice.reducer;
